import { STEPS } from '../types';

interface StepIndicatorProps {
  currentStep: number;
}

function getStepStatus(stepId: number, currentStep: number) {
  if (stepId < currentStep) return 'completed';
  if (stepId === currentStep) return 'current';
  return 'upcoming';
}

export default function StepIndicator({ currentStep }: StepIndicatorProps) {
  const progressPercent = ((currentStep - 1) / 4) * 100;

  return (
    <div className="mb-8">
      <div className="w-full h-2 rounded-full bg-background-200 overflow-hidden">
        <div
          className="h-full rounded-full bg-primary-500 transition-all duration-500 ease-out"
          style={{ width: `${progressPercent}%` }}
        ></div>
      </div>
      <div className="flex items-center justify-between mt-3 px-1">
        {STEPS.map((step) => {
          const status = getStepStatus(step.id, currentStep);
          return (
            <div
              key={step.id}
              className="flex flex-col items-center gap-1"
              style={{ width: `${100 / STEPS.length}%` }}
            >
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${
                  status === 'completed'
                    ? 'bg-primary-500 text-background-50'
                    : status === 'current'
                    ? 'bg-primary-500 text-background-50 ring-4 ring-primary-200 scale-110'
                    : 'bg-background-200 text-foreground-400'
                }`}
              >
                {status === 'completed' ? (
                  <i className="ri-check-line text-xs font-bold"></i>
                ) : (
                  <i className={`${step.icon} text-sm`}></i>
                )}
              </div>
              <span
                className={`text-[10px] text-center hidden md:block leading-tight transition-colors ${
                  status === 'current'
                    ? 'text-primary-600 font-semibold'
                    : status === 'completed'
                    ? 'text-primary-500'
                    : 'text-foreground-400'
                }`}
              >
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}